import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import PropTypes from "prop-types";

const ProtectedPage = ({ children, allowedRoles }) => {
  const { instance } = useMsal();
  const [activeAccount, setActiveAccount] = useState(instance.getActiveAccount());
  const [userRoles, setUserRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Function to handle roles and active account
  const initializeAccountAndRoles = async () => {
    try {
      // Handle redirect and check for an active account
      const response = await instance.handleRedirectPromise();
      let account = activeAccount;

      if (response?.account) {
        instance.setActiveAccount(response.account);
        account = response.account;
      } else if (!account) {
        const accounts = instance.getAllAccounts();
        if (accounts.length > 0) {
          instance.setActiveAccount(accounts[0]);
          account = accounts[0];
        }
      }

      if (!account) {
        console.log("No active account found.");
        return;
      }

      setActiveAccount(account);

      // Extract roles from token
      const token = account?.idTokenClaims;
      if (token?.roles) {
        setUserRoles(token.roles);
        console.log("Roles found in token:", token.roles);
      } else {
        console.log("No roles found in token.");
        setUserRoles([]);
      }
    } catch (error) {
      console.error("Error handling redirect or retrieving roles:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initializeAccountAndRoles();
  }, [instance, activeAccount]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!activeAccount) {
    console.log("No active account. Redirecting to sign-in.");
    return <Navigate to="/authentication/sign-in" />;
  }

  // Check user access based on roles
  const hasAccess =
    allowedRoles.length === 0 || userRoles.some((role) => allowedRoles.includes(role));

  if (!hasAccess) {
    console.log("Access denied. Redirecting to unauthorized.");
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

ProtectedPage.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ProtectedPage;
